import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { replace } from '../../../../utils/func';
import ProductOrdersItem from '../ProductOrdersItem/ProductOrdersItem';
import SpecifyOrder from '../SpecifyOrder/SpecifyOrder';
import styles from './OrdersInfo.module.scss';

const OrdersInfo = ({ order, OrderState }) => {
  const [specifyOrderState, setspecifyOrderState] = useState(false);
  const [orderState, setOrderState] = useState(order);
  console.log("🚀 ~ OrdersInfo ~ order:", order)

  const {
    email,
    phone,
    paymentMethod,
    deliveryAddress,
    paymentInfo,
    totalSum,
    comment,
    products,
    status,
    _id: id,
  } = orderState;

  const normalizedTotalSum =
    typeof totalSum === 'object'
      ? Number(totalSum.$numberDecimal)
      : Number(totalSum || 0);

  const isMonoCredit = paymentMethod === 'MonoCredit';
  const isMonoPay = paymentMethod === 'MonoPay';

  const partsCount = Number(paymentInfo?.partsCount || orderState?.monoPartsCount || 0);
  console.log("🚀 ~ OrdersInfo ~ paymentInfo:", paymentInfo)
  console.log("🚀 ~ OrdersInfo ~ partsCount:", partsCount)

  const monthlyPayment = paymentInfo?.monthlyPayment
    ? Number(paymentInfo.monthlyPayment)
    : partsCount
      ? normalizedTotalSum / partsCount
      : 0;

  const typePayment = isMonoCredit
    ? 'Оплата частинами monobank'
    : paymentMethod;

  const productList = products.map((p) => (
    <li key={p.product.itemNo}>
      <ProductOrdersItem product={p} />
    </li>
  ));

  return (
    <div className={styles.info}>
      {OrderState === 'specified' && (
        <div
          className={styles.specify}
          onClick={() => setspecifyOrderState(!specifyOrderState)}
        >
          Уточнити замовлення
        </div>
      )}
      <div>
        Email : <span className={styles.bold}>{email}</span>
      </div>
      <div>
        Номер телефона: <span className={styles.bold}>{phone}</span>
      </div>
      {specifyOrderState ? (
        <SpecifyOrder
          orderId={id}
          order={order}
          setspecifyOrderState={setspecifyOrderState}
          setOrderState={setOrderState}
        />
      ) : (
        <div>
          <div>
            Спосіб оплати: <span className={styles.bold}>{typePayment}</span>
          </div>
          {isMonoCredit && (
            <div className={styles.paymentDetails}>
              <div>
                Кількість платежів:{' '}
                <span className={styles.bold}>
                  {partsCount || 'Не вказано'}
                </span>
              </div>

              {partsCount > 0 && (
                <div>
                  Платіж на місяць:{' '}
                  <span className={styles.bold}>
                    {replace(monthlyPayment.toFixed(2))} грн.
                  </span>
                </div>
              )}

              <div>
                Сума для оплати частинами:{' '}
                <span className={styles.bold}>
                  {replace(
                    paymentInfo?.totalSum
                      ? paymentInfo.totalSum
                      : normalizedTotalSum.toFixed(2)
                  )}{' '}
                  грн.
                </span>
              </div>

              {paymentInfo?.state && (
                <div>
                  Статус mono:{' '}
                  <span className={styles.bold}>
                    {paymentInfo.state}
                    {paymentInfo.orderSubState
                      ? ` / ${paymentInfo.orderSubState}`
                      : ''}
                  </span>
                </div>
              )}

              {paymentInfo?.monoCreditOrderId && (
                <div>
                  ID заявки mono:{' '}
                  <span className={styles.bold}>
                    {paymentInfo.monoCreditOrderId}
                  </span>
                </div>
              )}

              {paymentInfo?.message && (
                <div>
                  Коментар mono:{' '}
                  <span className={styles.bold}>{paymentInfo.message}</span>
                </div>
              )}

              <div>
                Умови:{' '}
                <span className={styles.bold}>
                  перший платіж списується під час оформлення покупки,
                  наступні — щомісячно рівними частинами.
                </span>
              </div>
            </div>
          )}

          {isMonoPay && (
            <div className={styles.paymentDetails}>
              <div>
                Статус оплати:{' '}
                <span className={styles.bold}>
                  {status === 'processed'
                    ? 'Оплачено'
                    : status === 'payment_failed'
                      ? 'Не оплачено'
                      : 'Очікує оплату'}
                </span>
              </div>

              {orderState.monopayTransactionId && (
                <div>
                  Mono invoice ID:{' '}
                  <span className={styles.bold}>
                    {orderState.monopayTransactionId}
                  </span>
                </div>
              )}

              {paymentInfo?.message && (
                <div>
                  Коментар mono:{' '}
                  <span className={styles.bold}>{paymentInfo.message}</span>
                </div>
              )}
            </div>
          )}

          <div>
            Спосіб доставки:{' '}
            <span className={styles.bold}>{deliveryAddress?.delivery}</span>
          </div>

          {deliveryAddress && (
            <div>
              Адреса доставки:{' '}
              <span className={styles.bold}>
                {deliveryAddress?.region} обл., {deliveryAddress?.city},{' '}
                {deliveryAddress?.address}.
              </span>
            </div>
          )}
          <div>
            Коментарій: <span className={styles.bold}>{comment}</span>
          </div>
        </div>
      )}

      <div>
        Сума до сплати:{' '}
        <span className={styles.bold}>
          {replace(
            typeof totalSum === 'object' ? totalSum.$numberDecimal : totalSum
          )}{' '}
          грн.
        </span>
      </div>

      <div>
        Замовлення:{' '}
        <ul className={styles.productList}>{productList}</ul>
      </div>
    </div>
  );
};

OrdersInfo.propTypes = {
  order: PropTypes.object.isRequired,
};

export default OrdersInfo;